<template>
  <Layout> <RouterView /> </Layout>
</template>

<script>
import PageHeader from "../page-header";
import Layout from "./main";
export default {
  page: {
    title: "Tunesoft Audit Control Platform",
  },
  components: {
    Layout,
    PageHeader,
  },
  mounted() {
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-sidebar-size");
  },
  data() {
    return {
      title: "Tunesoft Audit Control Platform",
    };
  },
};
</script>
